<template>
  <router-view />
</template>
<script>
import MixinLib from '@/libs/MixinLib'

export default {
  name: 'StoresPage',

  mixins: [MixinLib],

  data: () => ({
  }),

  components: {
  }
}
</script>
